import ExceedSessionTypes from './ExceedSessionTypes';

export function loadExceedSessionPage (data) {
  return {
    type: ExceedSessionTypes.GET_PAGE_EXCEED_SESSION_REQUEST,
    payload: data
  };
}
